import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import HomeAdCarousel from "./HomeAdCarousel";
import * as actions from "../redux/actions/mostSearchedAdsActions";
import * as adActions from "../redux/actions/adActions";

class HomeMostSearchedAdsCarousel extends React.Component {
  componentDidMount() {
    if (this.props.token && this.props.user_id) {
      this.props.LoadList(this.props.user_id, this.props.token);
    }
  }

  render() {
    const { list, loading } = this.props;

    return (
      <HomeAdCarousel
        title={<Translate value="home_most_searched_ads_title" />}
        subtitle={<Translate value="home_most_searched_ads_subtitle" />}
        adList={list}
        loading={loading}
        onAdClick={this.props.SetAd}
        seeMoreTo="/home/most-searched"
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    list: reducer.mostSearchedAds.list,
    loading: reducer.mostSearchedAds.loading && !reducer.mostSearchedAds.loaded,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadList: (user_id, token) => dispatch(actions.loadList({ user_id, token })),
  SetAd: (item) => dispatch(adActions.setAd({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeMostSearchedAdsCarousel);
